import React from 'react';
import MUIDataTable from "mui-datatables";
import { CircularProgress } from "@mui/material";
import { ThemeProvider } from '@mui/material/styles';
import { tableTheme } from '../../../themes/tableTheme';
import { adalApiFetch } from '../../../../adalConfig';
import { handlePagination, postApi } from "../../../utils/apiFunction";
import DataTableStandard from "../../../components/DataTableStandard";
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from "@mui/material/IconButton";
import { useJumboTheme } from "@jumbo/hooks";
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import { reload } from 'firebase/auth';

const Roles = (props) => {
    const uri = process.env.REACT_APP_BASE_URL;
    const { theme } = useJumboTheme();
    const Swal = useSwalWrapper();
    const [loading, setLoading] = React.useState(false);
    const [columns, setColumns] = React.useState([]);
    const [procurement, setProcurement] = React.useState([]);

    const deleteRole = React.useCallback(async (dataIndex) => {
        const rowObj = procurement[dataIndex];
        const name = rowObj?.name ?? dataIndex;
        Swal.fire({
            html: 'Are you sure you want to delete this mapping?',
            icon: 'warning',
            title: 'Confirm Delete...',
            showCancelButton: true,
            confirmButtonText: 'Yes, Continue',
            cancelButtonText: 'No',

        }).then(async result => {
            if (result.value) {
                setLoading(true);
                const id = rowObj?.id;
                await postApi('/Roles/Delete/' + id);
                props.reloadFunc(); 
                setLoading(false);                
            } else if (result.dismiss === Swal.DismissReason.cancel) {

            }
        });
    }, [procurement, props.reload]);


    React.useEffect(() => {
        var cols = [{
            name: 'name',
            label: 'Name',
        },
        {
            name: 'userId',
            label: 'User Id (Email)',
        },
        {
            name: 'delete',
            label: 'Delete',
            options: {
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <IconButton
                            aria-label="delete"
                            onClick={(e) => { e.stopPropagation(); deleteRole(dataIndex); }}
                            title="Delete"
                        >
                            <DeleteIcon sx={{ fontSize: 18 }} />
                        </IconButton>
                    );
                },
            }
        }]
        setColumns(cols);
    }, [procurement])

    const options = {
        filterType: 'dropdown',
        selectableRowsHideCheckboxes: true,
        fixedHeader: true,
        tableBodyMaxHeight: '600px',
        responsive: 'standard',
        onRowClick: props.onClick ? props.onClick(procurement) : (() => { })
    };

    React.useEffect(() => {
        setProcurement([]);
        getProcurementData();
    }, [props.reload]);

    var getProcurementData = async () => {
        setLoading(true);
        const response = await adalApiFetch(fetch, uri + '/Roles/Get');
        const data = await response.json();
        console.log(data)
        setLoading(false);
        setProcurement(data);
    }

    return (
        <DataTableStandard
            data={props.filter ? props.filter(procurement) : procurement}
            title={"User Roles"}
            columns={columns}
            options={options}
            returnSearch={!loading}
            reload={props.reloadFunc}
        />
    );
};

export default Roles;
